import { AbstractControl, NG_VALIDATORS, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, OnInit } from '@angular/core';

import { nie } from './validator';

@Directive({
    selector: '[nie][formControlName],[nie][formControl],[nie][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => NIEValidatorDirective),
            multi: true,
        },
    ],
})
export class NIEValidatorDirective implements Validator, OnInit {
    private validator: ValidatorFn;

    ngOnInit() {
        this.validator = nie();
    }

    validate(c: AbstractControl): { [key: string]: any } {
        return this.validator(c);
    }
}
